// extracted by mini-css-extract-plugin
export default {"autocomplete":"autocomplete_autocomplete__DQSRh","text_highlight":"autocomplete_text_highlight__CL3MG","title":"autocomplete_title__KXifY"};